import Gallery from '../Stores/Gallery';
import Helper from './Helper';
import Product from '../Stores/Product';
import {get} from 'svelte/store';

export default class Post {
	nextPosition(order) {
		if (Helper.undefined(this.position))
			this.position = 0;

		this.position += parseInt(order) || 0;
		return this.position;
	}

	option(product, session, property) {
		const info_hidden = `info_${product.id}[option_hidden][${property.option_id}]`;
		session[`option_${product.id}[${property.option_id}]`] = property.selected.value;
		session[`${info_hidden}[value]`] = 1;
		session[`${info_hidden}[hidden]`] = 1;

		const info_option = `info_${product.id}[option][${property.option_id}]`;
		session[`${info_option}[name]`] = property.name;
		session[`${info_option}[value]`] = property.selected.text;
		session[`${info_option}[position]`] = this.nextPosition(property.order);
		session[`${info_option}[suffix]`] = property.unit;
		session[`${info_option}[optional]`] = property.required ? 0 : 1;
		session[`${info_option}[hidden]`] = property.visible ? 0 : 1;
		return session;
	}

	info(product, session, property) {
		const info_shop = `info_${product.id}[shopinfo][${property.info_id}]`;
		session[`${info_shop}[name]`] = property.name;
		session[`${info_shop}[value]`] = property.selected.text;
		session[`${info_shop}[position]`] = this.nextPosition(property.order);
		return session;
	}

	upgrade(product, session, property) {
		const id = property.selected.value;
		const upgrade = property.selected.upgrade;
		const position = this.nextPosition(property.order);
		const count = property.selected.count || 0;
		let price = property.selected.price || 0;
		if (price && count) price /= count;

		const info_hidden = `info_${product.id}[upgrade_hidden][${id}]`;
		session[`upgrade_${product.id}[${upgrade}]`] = id;
		session[`${info_hidden}[value]`] = 1;
		session[`${info_hidden}[hidden]`] = 1;

		const info_upgrade = `info_${product.id}[upgrade][${id}]`;
		session[`${info_upgrade}[name]`] = property.name;
		session[`${info_upgrade}[value]`] = property.selected.label;
		session[`${info_upgrade}[price]`] = 0;
		session[`${info_upgrade}[position]`] = position;
		session[`${info_upgrade}[optional]`] = property.required ? 0 : 1;
		session[`${info_upgrade}[hidden]`] = property.visible ? 0 : 1;

		if (price) {
			const info_price = `info_${product.id}[upgrade_price][${id}]`;
			session[`${info_price}[name]`] = 'Prijs';
			session[`${info_price}[value]`] = price;
			session[`${info_price}[position]`] = position;
			session[`${info_price}[hidden]`] = 1;
		}

		if (count) {
			const info_count = `info_${product.id}[upgrade_count][${id}]`;
			session[`${info_count}[name]`] = 'Aantal';
			session[`${info_count}[value]`] = count;
			session[`${info_count}[position]`] = position;
			session[`${info_count}[hidden]`] = 1;
		}

		return session;
	}

	upsell(product, session, property) {
		for (let item of property.selected.data) {
			const name = item.selection ? item.label : property.name;
			const value = item.selection || item.label;
			const info_upsell = `info_${product.id}[upsell][${item.group}]`;

			session[`upsell_${product.id}[${item.group}]`] = item.group;
			session[`${info_upsell}[name]`] = name;
			session[`${info_upsell}[value]`] = value;
			session[`${info_upsell}[position]`] = this.nextPosition(property.order);
			session[`${info_upsell}[optional]`] = property.required ? 0 : 1;
			session[`${info_upsell}[hidden]`] = 1;
		}

		return session;
	}

	bundle(product, session, property) {
		const id = property.selected.id;
		const info_bundle = `info_${product.id}[bundle][${id}]`;

		session[`bundle_${product.id}[${id}]`] = id;
		session[`${info_bundle}[name]`] = property.selected.label;
		session[`${info_bundle}[value]`] = property.selected.id;
		session[`${info_bundle}[position]`] = this.nextPosition(property.order);
		session[`${info_bundle}[hidden]`] = 1;
		return session;
	}

	image(product, session) {
		const main = Gallery.main();
		if (main) {
			const info = `info_${product.id}[image][configurator]`;
			session[`${info}[name]`] = 'image';
			session[`${info}[value]`] = main.image;
			session[`${info}[hidden]`] = 1;
		}

		return session;
	}

	json(product, session) {
		const info = `info_${product.id}[session][0]`;
		session[`${info}[name]`] = 'configurator_v2';
		session[`${info}[value]`] = JSON.stringify(product);
		session[`${info}[hidden]`] = 1;
		return session;
	}

	session() {
		let session = {configurator: true, skip_response: 1};
		const product = get(Product);
		if (Array.isArray(product.steps))
			for (let step of product.steps)
				for (let property of step.properties)
					if (Helper.is(property.selected))
						switch (property.property_type) {
							case 'options': session = this.option(product, session, property); break;
							case 'infos': session = this.info(product, session, property); break;
							case 'upgrades': session = this.upgrade(product, session, property); break;
							case 'upsells': session = this.upsell(product, session, property); break;
							case 'bundles': session = this.bundle(product, session, property); break;
						}

		session = this.image(product, session);
		session = this.json(product, session);
		return session;
	}

	async post() {
		const session = this.session();
		console.info(session);

		const data = new FormData();
		for (let field in session)
			data.append(field, session[field]);

		const url = Product.getURL();
		const config = {method: 'POST', body: data};
		const response = await fetch(url, config);
		return response.status == 200;
	}
}